export const Primary = '#000000';
export const Secondary = '#FFFFFF';
export const NoteColor = '#828282';
